module.exports = __webpack_public_path__ + "static/media/call-feedback-technical-issues-color.70acfac2.svg";